export class SearchFilter {
  public propertyName: string;
  public operation: string;
  public value: string | boolean | number;
  public toLower: boolean;
  public unaryOperation: number;
  public binaryOperation: number;
}
